// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as $$String from "rescript/lib/es6/string.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_string from "rescript/lib/es6/caml_string.js";
import * as Dom_storage from "rescript/lib/es6/dom_storage.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";

function MakeLocalStorage(T) {
  var getItem = function (key) {
    try {
      return Dom_storage.getItem(Curry._1(T.keyToJs, key), localStorage);
    }
    catch (raw__e){
      var _e = Caml_js_exceptions.internalToOCamlException(raw__e);
      if (_e.RE_EXN_ID === Js_exn.$$Error) {
        return ;
      }
      throw _e;
    }
  };
  var remove = function (key) {
    try {
      return Dom_storage.removeItem(Curry._1(T.keyToJs, key), localStorage);
    }
    catch (exn){
      return ;
    }
  };
  var setItem = function (key, value) {
    try {
      return Dom_storage.setItem(Curry._1(T.keyToJs, key), value, localStorage);
    }
    catch (raw__e){
      var _e = Caml_js_exceptions.internalToOCamlException(raw__e);
      if (_e.RE_EXN_ID === Js_exn.$$Error) {
        return ;
      }
      throw _e;
    }
  };
  return {
          keys: T.keys,
          getItem: getItem,
          remove: remove,
          setItem: setItem
        };
}

function removeLeadingCharacterMatch(trimCharacter, trimString) {
  var len = trimString.length;
  if (len <= 0) {
    return "";
  }
  var myChar = Caml_string.get(trimString, 0);
  if (myChar === trimCharacter) {
    return $$String.sub(trimString, 1, trimString.length - 1 | 0);
  } else {
    return trimString;
  }
}

function getQueryStringFromBrowser(param) {
  return removeLeadingCharacterMatch(/* '?' */63, window.location.search);
}

function getQueryParameter(parameter, queryString) {
  var kvPairs = Belt_List.fromArray(Js_string.split("&", queryString));
  var maybeParameter = Belt_List.getBy(kvPairs, (function (x) {
          return Js_string.startsWith(parameter + "=", x);
        }));
  if (maybeParameter === undefined) {
    return ;
  }
  var t = Belt_List.tail(Belt_List.fromArray(Js_string.split("=", maybeParameter)));
  if (t !== undefined) {
    return Belt_List.toArray(t).join("=");
  }
  
}

function getAllQueryParamsFromQuery(query) {
  var _queryParams = Belt_List.flatten(Belt_List.fromArray(Belt_Array.map(Js_string.split("&", Js_string.concatMany(Js_string.split("?", query), "")), (function (str) {
                  return Belt_List.fromArray(Js_string.split("=", str));
                }))));
  var _jointParams = /* [] */0;
  while(true) {
    var jointParams = _jointParams;
    var queryParams = _queryParams;
    if (!queryParams) {
      return jointParams;
    }
    var match = queryParams.tl;
    var name = queryParams.hd;
    if (!match) {
      return Belt_List.setAssoc(jointParams, name, "", (function (prim0, prim1) {
                    return prim0 === prim1;
                  }));
    }
    var rest = match.tl;
    var value = match.hd;
    if (!rest) {
      return Belt_List.setAssoc(jointParams, name, value, (function (prim0, prim1) {
                    return prim0 === prim1;
                  }));
    }
    _jointParams = Belt_List.setAssoc(jointParams, name, value, (function (prim0, prim1) {
            return prim0 === prim1;
          }));
    _queryParams = rest;
    continue ;
  };
}

function getAllQueryParams(param) {
  return getAllQueryParamsFromQuery(window.location.search);
}

var QueryString = {
  removeLeadingCharacterMatch: removeLeadingCharacterMatch,
  getQueryStringFromBrowser: getQueryStringFromBrowser,
  getQueryParameter: getQueryParameter,
  getAllQueryParamsFromQuery: getAllQueryParamsFromQuery,
  getAllQueryParams: getAllQueryParams
};

export {
  MakeLocalStorage ,
  QueryString ,
}
/* No side effect */
